const PREVIEW_PREFIX = /^\/preview(?=\/|$)/;

export const buildShallowUrl = (asPath: string, params: URLSearchParams): string => {
  const basePath = asPath.split('?')[0].replace(PREVIEW_PREFIX, '');
  const query = params.toString();
  return `${basePath}${query ? `?${query}` : ''}`;
};

export const buildUpdatedQueryUrl = (
  asPath: string,
  type: 'ADD' | 'DELETE',
  name: string,
  value: string | null,
): string => {
  const params = new URLSearchParams(asPath.split('?')[1] || '');
  if (type === 'DELETE') {
    params.delete(name);
  } else if (value !== null) {
    params.set(name, value);
  }
  return buildShallowUrl(asPath, params);
};

export const buildResetFiltersUrl = (asPath: string, filters: string[]): string => {
  const params = new URLSearchParams(asPath.split('?')[1] || '');
  filters.forEach((filter) => params.delete(filter));
  return buildShallowUrl(asPath, params);
};
